import React from 'react'
class notFound extends React.Component {
  render() {
    return <h1>Page Not Found 404</h1>
  }
}
export default notFound